module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h2', {
    staticClass: "h2sub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("THE WORLD OF REAL ESTATE INVESTING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most people think of real estate investing as owning property to either rent out or flip. They’re right, but real estate investing includes much more, from those physical money-making properties to real estate–related stocks to real estate investment clubs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For people who prefer a hands-off approach, investing in real estate mutual funds, real estate investment trusts (REITs), and crowdfunded real estate provides the opportunity to reap rewards without the work and for much smaller investments. All it takes to get started is a little bit of money, some research, and a desire to build wealth.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 69
// module chunks = 0